import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"

import footerStyles from "./footer.module.scss"


const Footer = () => {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          author
        }
      }
    }
  `)

  return (
    <footer className={footerStyles.footer}>
      <div className={footerStyles.textbox}>
       
        <p>
          designed by{" "}
          <Link to="http://pawelstyczen.com">
            PawelStyczen.com
          </Link>
        </p>
      </div>
    </footer>
  )
}

export default Footer
